import React, { useState } from 'react';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import Form from 'react-bootstrap/Form';
import SeriesPitcherList from '../../../components/playerList/SeriesPitcherList';
import {teamListObj} from '../../../utils/team/teamSetting';
import { useTranslation } from 'react-i18next';

function NextPitcher({teamObj, checked, profile}) {
    let [pitcherTeamObj, setPitcherTeamObj] = useState(teamObj);
    const { t } = useTranslation();

    let useLang = localStorage.getItem('language');

    if(pitcherTeamObj['teamId'] === 0 ) {
        return (
            <>
            <div className="boxTitle">
                {t('opposingPitcher')} : {pitcherTeamObj['teamName']}
            </div>
            <SeriesPitcherList teamObj={pitcherTeamObj} title={'starter'} 
            pitcherType={5102} checked={checked} profile={profile}/>
            <SeriesPitcherList teamObj={pitcherTeamObj} title={'bullpen'} 
            pitcherType={5104} checked={checked} profile={profile}/>
            </>
        )
    }

    let teamList = teamListObj();

    function nextTeamSelectHandler(event) {
        let type = event.target.value;
        let index = event.nativeEvent.target.selectedIndex;
        let teamName = event.nativeEvent.target[index].text;

        setPitcherTeamObj({
            teamId: type, teamName
        });
    }

    return (
        <>
        <div style={{position:'absolute', top: '-35px'}}>
            <Form.Group onChange={nextTeamSelectHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={pitcherTeamObj['teamId']}>
                {
                    teamList.map((item) => (
                        <option value={item['teamId']} key={item['teamId']}>
                            {useLang === "en" ? item['teamEngName'] : item['teamName']}
                        </option>
                    ))
                }
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle">
            {t('opposingPitcher')} : {pitcherTeamObj['teamName']}
        </div>
        <SeriesPitcherList teamObj={pitcherTeamObj} title={'starter'} 
        pitcherType={5102} checked={checked} profile={profile}/>
        <SeriesPitcherList teamObj={pitcherTeamObj} title={'bullpen'} 
        pitcherType={5104} checked={checked} profile={profile}/>
        </>
    )
}

export default NextPitcher;